import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-1">
      <Button
        variant={language === 'sk' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => setLanguage('sk')}
        className="px-2 py-1 text-sm font-medium flex items-center gap-1"
      >
        <img src="/slovak-flag.png" alt="Slovak" className="w-4 h-3 object-cover rounded-sm" />
        SK
      </Button>
      <Button
        variant={language === 'en' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => setLanguage('en')}
        className="px-2 py-1 text-sm font-medium flex items-center gap-1"
      >
        <img src="/english-flag.png" alt="English" className="w-4 h-3 object-cover rounded-sm" />
        EN
      </Button>
    </div>
  );
};

export default LanguageSwitcher;